import React from "react"
import { cn } from "design_system/libs"
import { actionKeys, actionTranslations, type ActionKey } from "@love-irish/i18n"

export interface ReadMoreLinkProps {
  /** URL to link to */
  href?: string
  /** Use actionTranslations for i18n (default: false uses "Léigh mó · Read more") */
  useI18n?: boolean
  /**
   * Action for the i18n CTA, referenced from the `actionKeys` object, e.g. `actionKeys.LISTEN`
   * (defaults to `actionKeys.READ`). This is the action VALUE, so it indexes `actionTranslations`
   * directly and stays in sync with the type's canonical action.
   */
  actionKey?: ActionKey
  /** Additional CSS classes */
  className?: string
}

export const ReadMoreLink: React.FC<ReadMoreLinkProps> = ({
  href,
  useI18n = false,
  actionKey = actionKeys.READ,
  className,
}) => {
  if (!href) return null

  const text = useI18n
    ? actionTranslations[actionKey].cta
    : { translation: "Léigh mó", text: "Read more" }

  return (
    <div className={cn("mt-4", className)}>
      <a href={href}>
        <strong>{text.translation}</strong> &middot; <em>{text.text}</em> &rarr;
      </a>
    </div>
  )
}

export default ReadMoreLink
